// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.2957","1.2956"][{"204":0,"556":1,"654":0,"677":1,"958":0}[chunkId]] || "1.2959") + "/" + ({"141":"whisper-i18n","206":"nudge-adapter-onboarding","654":"central-engagement-orchestrator","817":"nudge-adapter-components","933":"whisper-core-entry"}[chunkId] || chunkId) + ".js";
};